module.exports = __webpack_public_path__ + "static/media/Medidas_2_4_5_6.e2c3a658.pdf";